export enum DeliveryItems {
    all = 0,
    lineByLine = 1
}
